// This is the root of our app
// Will contain the app client and auth provider and link to router

import React, { useEffect } from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import ls from 'local-storage';

//import { getClient } from '@squirrellearningltd/go-shared-utils';
import { getClient } from '../../services/utils/client';
import { ErrorPage, Ssl } from '@squirrellearningltd/go-shared-components';

import { AuthProvider } from '../../services/auth/AuthProvider';
import { APP_NAME } from '../../services/constants';
import AppRouter from './components/AppRouter';
import ReactGA from 'react-ga4';

const hostname = window && window.location && window.location.hostname;

Bugsnag.start({
    apiKey: '112ef5bd7b0c7c164caf36e3c5198c23',
    plugins: [new BugsnagPluginReact()],
    metadata: {
        app: 'Teacher GoWrite',
        releaseName: hostname === 'localhost' ? 'development' : !hostname.includes('staging') ? 'production' : 'staging'
    },
    enabledReleaseStages: [ 'production', 'staging' ],
    onError: (event) => {
        const user = JSON.parse(ls('go_teacher_user'));
        if (user && user.id && user.email) {
            event.setUser(user.id, user.email, `${user.firstName} ${user.lastName}`);
        } else {
            event.setUser('unknown', 'unknown', 'unknown');
        }
    }
});

const ErrorBoundary = Bugsnag.getPlugin('react')
    .createErrorBoundary(React);

const Home = () => {

    useEffect(() => {
        ReactGA.initialize(process.env.REACT_APP_GA_ID);
        ReactGA.send({
            hitType: 'pageview',
            page: window.location.pathname,
        });
    }, []);
    return (
        <ErrorBoundary FallbackComponent={ErrorPage}>
            <ApolloProvider client={getClient(APP_NAME)} >
                <Ssl />
                <AuthProvider>    
                    <AppRouter />
                </AuthProvider>
            </ApolloProvider>
        </ErrorBoundary>
        
    )
}

export default Home;
